import { Button } from '@chakra-ui/react';

type TProps = { children: string; onClick?: () => void; isDisabled?: boolean; loading?: boolean };

const AuthButton = ({ children, onClick, isDisabled, loading }: TProps) => (
    <Button
        fontSize="md"
        variant="brand"
        fontWeight="600"
        w="100%"
        h="48px"
        mb="24px"
        onClick={onClick}
        isDisabled={isDisabled}
        isLoading={loading}
    >
        {children}
    </Button>
);

export default AuthButton;
